<a
  class="component-small-medium px-sm py-xs gap-xs border-stroke-primary-darker bg-components-background-primary-lightest text-components-content-primary-darker flex w-fit max-w-[280px] items-center rounded-full border text-ellipsis whitespace-nowrap"
  [hlmDropdownMenuTrigger]="menu"
  href="#"
>
  <span class="w-full overflow-x-hidden text-ellipsis">{{ label() }}</span>
  <ng-icon name="lucideChevronDown" hlm size="sm" />
</a>

<ng-template #menu>
  <hlm-dropdown-menu class="w-max">
    @if (showSearchbar() || multiple()) {
      <hlm-dropdown-menu-group>
        @if (showSearchbar()) {
          <hlm-input-group>
            <input id="input-group-url" [(ngModel)]="search" hlmInputGroupInput placeholder="Rechercher" />
            <hlm-input-group-addon align="inline-end">
              <ng-icon name="lucideSearch" />
            </hlm-input-group-addon>
          </hlm-input-group>
        }

        @if (multiple()) {
          <button
            [checked]="areAllItemsSelected()"
            [indeterminate]="!areAllItemsSelected()"
            (triggered)="toggleAll()"
            hlmDropdownMenuCheckbox
          >
            <hlm-dropdown-menu-checkbox-indicator />
            <span>Tout sélectionner</span>
          </button>
        }
        <hlm-dropdown-menu-separator />
      </hlm-dropdown-menu-group>
    }
    <hlm-dropdown-menu-group>
      @for (item of filteredItems() | trierPar: sortKey(); track item.key) {
        <button [checked]="isChecked(item.key)" (triggered)="onSelect(item.key)" hlmDropdownMenuCheckbox>
          <hlm-dropdown-menu-checkbox-indicator />
          <span>{{ item.value }}</span>
        </button>
      } @empty {
        <button hlmDropdownMenuItem>Aucun résultat pour votre recherche</button>
      }
    </hlm-dropdown-menu-group>
  </hlm-dropdown-menu>
</ng-template>
